module.exports = __webpack_public_path__ + "static/media/inspo.afa6596f.png";